import {Restrictions} from './restrictions.model';

export class Profile {
  roleId: number;
  nameRole: string;
  uid: string;
  restrictions: Restrictions[];
}
